import React, { useState, useContext, useEffect, useMemo } from "react";
import AuthLayout from "./AuthLayout";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { AuthContext } from "../../contextAPI's/authContext";
import BasicAlerts from "../../Components/Boxes/ErrorAndSuccess";
import { FlexBox } from "../../Components/Boxes/index";
import CircularLoader from "../../Components/Icons/circularLoader";
import { Link } from "react-router-dom";

export default function SendPasswordReset() {
    const [errorMessage, setErrorMessage] = useState("")
    const [successMessage, setSuccessMessage] = useState("")

    //auth context
    const { loading, ConfirmPasswordReset, SendPasswordReset, } = useContext(AuthContext)

    //States
    const [values, setValues] = useState({
        email: "",
    });

    //event change func
    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    //handle submit func
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage(null)
        setErrorMessage(null)
        SendPasswordReset({
            email: values.email,
            onSuccess: (msg) => {
                setSuccessMessage(msg)
            },
            onError: (err) => {
                setErrorMessage(err)
            }
        })
    };


    return (
        <AuthLayout title="Reset password">
                <form
                    onSubmit={handleSubmit}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <TextField
                        id="email"
                        type="email"
                        value={values.email}
                        onChange={handleChange("email")}
                        label="Email"
                        required
                        fullWidth
                    />
                    <br />
                    {errorMessage && (
                        <FlexBox $marginTop={2}>
                            <BasicAlerts $type="error">{errorMessage}</BasicAlerts>
                        </FlexBox>
                    )}
                    {successMessage && (
                        <FlexBox $marginTop={2}>
                            <BasicAlerts $type="success">{successMessage}</BasicAlerts>
                        </FlexBox>
                    )}
                    <br />
                    {!loading ? (
                        <Button
                            type="submit" fullWidth
                            variant="contained"
                            size="large"
                        >
                            Submit
                        </Button>
                    ) : (
                        <Button variant="contained" size="large" fullWidth disabled >
                            {/* {newStaffGetStatus !== asyncStates.PENDING ? 'Send Invitation Code' : <CircularLoader $color="white" $size={25} />} */}
                            <CircularLoader $color="white" $size={25} />
                        </Button>
                    )}
                    <br />
                    <Link to="/">Login</Link>
                </form>
            </AuthLayout>
    );
}
